import 'leaflet/dist/leaflet.css';

import { useEffect } from 'react';
import L from 'leaflet';
import { MapContainer, TileLayer, Marker, useMap } from 'react-leaflet';

// @ts-ignore
// eslint-disable-next-line
import icon from 'leaflet/dist/images/marker-icon.png';
// @ts-ignore
// eslint-disable-next-line
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

const DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
});

L.Marker.prototype.options.icon = DefaultIcon;

const ResizeHandler = () => {
    const map = useMap();

    useEffect(() => {
        // Invalidate map size after a short delay to allow modal animation to complete
        const timer = setTimeout(() => {
            map.invalidateSize();
        }, 300); // The modal transition is 300ms

        return () => {
            clearTimeout(timer);
        };
    }, [map]);

    return null;
};

interface MapProps {
  latitude: number;
  longitude: number;
}

export const Map = ({ latitude, longitude }: MapProps) => {
  return (
    <MapContainer
      center={[latitude, longitude]}
      zoom={13}
      scrollWheelZoom={false}
      style={{ height: '100%', width: '100%' }}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Marker position={[latitude, longitude]} />
      <ResizeHandler />
    </MapContainer>
  );
};
